<template>
  <section class="section">
    <div class="columns">
      <div class="column is-one-third is-offset-4">
        <div class="box">
          <h1>{{ $t('models.auth.registration') }}</h1>
          <form ref="form" @submit.prevent="submit">
            <v-text-field
              v-model.trim="user.first_name"
              :label="$t('models.auth.firstName') + ' *'"
              required
            />
            <v-text-field
              v-model.trim="user.last_name"
              :label="$t('models.auth.lastName') + ' *'"
              required
            />
            <v-text-field
              v-model.trim="user.username"
              :label="$t('models.auth.username') + ' *'"
              required
            />
            <v-text-field
              v-model.trim="user.email"
              :label="$t('models.auth.email') + ' *'"
              type="email"
              required
            />
            <hr />
            <ContainerWithErrorMessage :error-message="errorMessage" />

            <p class="control">
              <v-btn type="submit"> Register </v-btn>
              <router-link :to="{ name: 'login' }">
                <v-btn class="button is-text">Cancel</v-btn>
              </router-link>
            </p>
          </form>
        </div>
      </div>
    </div>
  </section>
  <LoadingOverlay v-model:loading="loading" />
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { apiClientV2 } from '@/api/ApiClientV2'
import errorHandler from '@/api/ErrorHandler'
import ContainerWithErrorMessage from '@/components/common/ContainerWithErrorMessage.vue'
import LoadingOverlay from '@/components/common/LoadingOverlay.vue'
import { Profile } from '@/models/core/profile'
const router = useRouter()
const store = useStore()
const loading = ref(false)
const errorMessage = ref('')
const user = ref({
  first_name: '',
  last_name: '',
  username: '',
  email: '',
})
const form = ref(null)
const redirectUser = () => {
  let url = '/'
  if (router.currentRoute.value.query.afterLoginUrl) {
    url = router.currentRoute.value.query.afterLoginUrl as string
  }
  router.push({ path: url })
}

const submit = () => {
  register()
}

const onVerify = (event) => {
  register()
}

const register = async () => {
  if (form.value.checkValidity()) {
    loading.value = true
    try {
      await apiClientV2.create(Profile, user)
      // TODO figure out how to show a toast
      // $buefy.toast.open({
      //   message: $t('models.auth.successfulRegistration'),
      //   type: 'is-success',
      // })
      router.push({
        name: 'activate_profile',
        query: {
          username: user.value.username,
          email: user.value.email,
        },
      })
    } catch (error) {
      errorMessage.value = errorHandler.errorToString(error)
    }
    loading.value = false
  }
}

onMounted(() => {
  if (
    store.state.global.isLoggedIn ||
    !store.getters['global/registrationEnabled']
  ) {
    redirectUser()
  }
})
</script>

<style lang="scss"></style>
